var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1953 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2216,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sticky-header",
    transform: "matrix(3.81445,0,0,1,2216,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.143369,0,0,0.546875,-210.671,-200.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1730,577C1871.29,577 1986,691.71 1986,833C1986,974.29 1871.29,1089 1730,1089C1588.71,1089 1474,974.29 1474,833C1474,691.71 1588.71,577 1730,577ZM1763.44,799.563L1763.44,724.5L1696.56,724.5L1696.56,799.563L1621.5,799.563L1621.5,866.438L1696.56,866.438L1696.56,941.5L1763.44,941.5L1763.44,866.438L1838.5,866.438L1838.5,799.563L1763.44,799.563Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.99675,0,0,11.431,-1881.89,-2353.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.985,229.407L661.953,229.407L661.953,233.919L658.241,233.919L658.241,222.591L661.937,222.591L661.937,226.767L661.969,226.767L664.993,222.591L669.473,222.591L665.217,227.775L669.681,233.919L665.009,233.919L661.985,229.407Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.537,234.239C674.652,234.239 673.881,234.117 673.225,233.871C672.569,233.626 672.022,233.29 671.585,232.863C671.148,232.437 670.822,231.933 670.609,231.351C670.396,230.77 670.289,230.143 670.289,229.471L670.289,222.591L674.097,222.591L674.097,229.055C674.097,229.599 674.228,230.023 674.489,230.327C674.75,230.631 675.121,230.783 675.601,230.783C676.081,230.783 676.452,230.631 676.713,230.327C676.974,230.023 677.105,229.599 677.105,229.055L677.105,222.591L680.897,222.591L680.897,229.471C680.897,230.143 680.782,230.77 680.553,231.351C680.324,231.933 679.985,232.437 679.537,232.863C679.089,233.29 678.532,233.626 677.865,233.871C677.198,234.117 676.422,234.239 675.537,234.239Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.849,222.591L687.729,222.591C688.284,222.591 688.836,222.647 689.385,222.759C689.934,222.871 690.425,223.069 690.857,223.351C691.289,223.634 691.638,224.013 691.905,224.487C692.172,224.962 692.305,225.557 692.305,226.271C692.305,226.965 692.134,227.575 691.793,228.103C691.452,228.631 690.961,229.039 690.321,229.327L693.201,233.919L688.817,233.919L686.641,229.871L686.529,229.871L686.529,233.919L682.849,233.919L682.849,222.591ZM686.497,227.375L687.249,227.375C687.377,227.375 687.518,227.365 687.673,227.343C687.828,227.322 687.972,227.277 688.105,227.207C688.238,227.138 688.35,227.042 688.441,226.919C688.532,226.797 688.577,226.634 688.577,226.431C688.577,226.229 688.54,226.069 688.465,225.951C688.39,225.834 688.294,225.746 688.177,225.687C688.06,225.629 687.932,225.591 687.793,225.575C687.654,225.559 687.526,225.551 687.409,225.551L686.497,225.551L686.497,227.375Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.425,222.591L701.473,222.591L705.889,233.919L701.745,233.919L701.153,232.255L697.553,232.255L696.993,233.919L692.961,233.919L697.425,222.591ZM699.393,226.543L698.465,229.343L700.305,229.343L699.393,226.543Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.689,
    y: 222.591,
    width: 3.84,
    height: 11.328,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.017,227.519L720.193,233.919L716.641,233.919L716.641,222.591L721.617,222.591L723.665,228.687L723.745,228.687L725.521,222.591L730.657,222.591L730.657,233.919L726.961,233.919L727.073,227.551L726.977,227.535L724.865,233.919L722.177,233.919L720.097,227.519L720.017,227.519Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.769,222.591L740.561,222.591L740.561,225.759L736.353,225.759L736.353,226.735L740.305,226.735L740.305,229.695L736.353,229.695L736.353,230.751L740.833,230.751L740.833,233.919L732.769,233.919L732.769,222.591Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.417,233.919L742.417,222.591L746.641,222.591C747.537,222.591 748.393,222.679 749.209,222.855C750.025,223.031 750.745,223.335 751.369,223.767C751.993,224.199 752.492,224.773 752.865,225.487C753.238,226.202 753.425,227.103 753.425,228.191C753.425,229.183 753.246,230.042 752.889,230.767C752.532,231.493 752.054,232.087 751.457,232.551C750.86,233.015 750.172,233.359 749.393,233.583C748.614,233.807 747.804,233.919 746.961,233.919L742.417,233.919ZM746.081,225.823L746.081,230.655L746.785,230.655C747.681,230.655 748.369,230.461 748.849,230.071C749.329,229.682 749.569,229.045 749.569,228.159C749.569,227.423 749.329,226.85 748.849,226.439C748.369,226.029 747.729,225.823 746.929,225.823L746.081,225.823Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755.025,
    y: 222.591,
    width: 3.84,
    height: 11.328,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.465,228.255C760.465,227.349 760.625,226.527 760.945,225.791C761.265,225.055 761.702,224.426 762.257,223.903C762.812,223.381 763.465,222.978 764.217,222.695C764.969,222.413 765.772,222.271 766.625,222.271C767.5,222.271 768.326,222.413 769.105,222.695C769.884,222.978 770.534,223.359 771.057,223.839L768.721,226.655C768.508,226.378 768.241,226.167 767.921,226.023C767.601,225.879 767.244,225.807 766.849,225.807C766.529,225.807 766.23,225.863 765.953,225.975C765.676,226.087 765.433,226.25 765.225,226.463C765.017,226.677 764.854,226.935 764.737,227.239C764.62,227.543 764.561,227.882 764.561,228.255C764.561,228.629 764.622,228.962 764.745,229.255C764.868,229.549 765.033,229.802 765.241,230.015C765.449,230.229 765.692,230.391 765.969,230.503C766.246,230.615 766.54,230.671 766.849,230.671C767.286,230.671 767.662,230.581 767.977,230.399C768.292,230.218 768.54,230.005 768.721,229.759L771.057,232.559C770.545,233.071 769.916,233.479 769.169,233.783C768.422,234.087 767.574,234.239 766.625,234.239C765.772,234.239 764.969,234.095 764.217,233.807C763.465,233.519 762.812,233.111 762.257,232.583C761.702,232.055 761.265,231.426 760.945,230.695C760.625,229.965 760.465,229.151 760.465,228.255Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.073,222.591L779.121,222.591L783.537,233.919L779.393,233.919L778.801,232.255L775.201,232.255L774.641,233.919L770.609,233.919L775.073,222.591ZM777.041,226.543L776.113,229.343L777.953,229.343L777.041,226.543Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.337,222.591L788.177,222.591L788.177,230.655L791.937,230.655L791.937,233.919L784.337,233.919L784.337,222.591Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullWhite);
export default __webpack_public_path__ + "static/media/logo-full-white.93d6b6ce34d904d20ee5cf6e8c8c5a54.svg";
export { ForwardRef as ReactComponent };